export function castPerson(p) {
  p["score_color"] = p.score.color
  delete p.score
  return p
}

export function personName(person) {
  return [
    person.first_name,
    person.nickname && `"${person.nickname}"`,
    person.last_name,
  ]
    .filter(Boolean)
    .join(" ")
}
